import * as React from "react";
import { CategorizedPageHelpRegistration, RenderRegistrationCardProps } from "../../../Registry/pageHelpRegistry";
import pageIds from "pageIds";
import { CommonTaskOverview, CommonTaskTopics } from "../../CommonComponents/CommonTaskViews";

export const TasksRegistration: CategorizedPageHelpRegistration = {
    page: pageIds.tasks.root,
    renderOverview: (renderProps: RenderRegistrationCardProps) => {
        return <CommonTaskOverview />;
    },
    renderTopics: (renderProps: RenderRegistrationCardProps) => {
        return <CommonTaskTopics />;
    },
};
